module.exports = __webpack_public_path__ + "img/saishianpai-icon-3.07a3ad2a.png";